"use strict"

export default class LoginController {
  /*@ngInject*/
  constructor(Auth, $state, $http) {
    this.Auth = Auth
    this.$state = $state
    this.$http = $http

    this.user = {
      name: "",
      email: "",
      password: "",
    }
    this.errors = {
      login: undefined,
    }
    this.submitted = false
  }

  login(form) {
    this.submitted = true

    if (form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password,
      })
        .then((user) => {
          // logged in then redirect to manage area of the map
          this.loginMessage = "Login successful"
          if (user.mapids?.length) {
            this.$state.go("mainmap.manage", { mapid: user.mapids[0] })
          }
        })
        .catch((err) => {
          this.errors.login = err.message
        })
    }
  }
}
